/**
 * @module tree/replaceChildren
 */

/**
 * @typedef {String|Number|DocumentFragment|Element|Text} Content
 */

import fragment from './fragment.js'
import append from './append.js'

/**
 * Replaces the current children of the provided target
 * by some new contents
 * @param {Document|DocumentFragment|Element} target
 * @param {...Content} contents
 */
export default (
  target,
  ...contents
) => {
  const { ownerDocument } = target
  const content = fragment(contents, ownerDocument)

  target.innerHTML = ''
  append(target, content)
}
